export default {
  deposit: {
    crypto: 'Cripto',
    fiatOrCash: 'Fiduciário/Dinheiro',
    depositCurrency: 'Moeda de Depósito',
    chooseNetwork: 'Escolher Rede',
    depositAddress: 'Endereço de depósito',
    copy: 'Copiar',
    copied: 'Copiado!',
    close: 'Fechar',
    more: 'Mais',
    select: 'Selecionar',
    channel: 'Canal',
    loading: 'Carregando...',
    noCurrency: 'Nenhuma moeda disponível',
    bonusTip: 'Aproveite um bônus de depósito no seu primeiro recarregamento, com até 200% de crédito adicional.',
    minDeposit: 'Depósito Mínimo',
    sendOnly: 'Envie apenas {currency} para este endereço de depósito. As moedas serão depositadas automaticamente após {confirmations} confirmações de rede.',
    depositAmount: 'Valor do Depósito',
    enterAmount: 'Digite o valor',
    confirmDeposit: 'Confirmar Depósito',
    depositTitle: 'Depósito',
    selectChannel: 'Selecionar Canal',
    subtitle: 'Rápido, seguro e conveniente',
    secureEncrypted: 'Seguro e Criptografado',
    terms: 'Ao continuar, você concorda com nossos Termos e Condições',
    totalDepositAmount: 'Valor total do depósito',
    fee: 'Taxa',
    arrivalAmount: 'Valor creditado',
    payMethod: 'Forma de Pagamento',
    cpf: 'CPF',
    enterCpf: 'Por favor, insira seu CPF',
    depositSuccess: 'Depósito realizado com sucesso!',
    depositFailed: 'Falha no depósito, tente novamente.',
    mockArrive: 'Chegada Simulada (Teste)',
    activity: {
      firstChargeTitle: 'Evento de Registro do Primeiro Depósito',
      firstChargeSubtitle: 'Registre seu primeiro depósito para receber recompensas exclusivas',
      dailyThreeTitle: 'Três Recargas Diárias',
      dailyThreeSubtitle: 'Complete 3 depósitos por dia para resgatar bônus extras',
      dailyPreviewLabel: 'Recompensa do Primeiro Depósito',
      upTo: 'Até {amount} {unit}',
      safeTitle: 'Seus fundos estão seguros conosco',
      safeDesc: 'Usamos segurança líder do setor para proteger suas transações e informações pessoais.',
      dailyFirst: '1ª Recarga Diária',
      dailySecond: '2ª Recarga Diária',
      dailyThird: '3ª Recarga Diária',
      lossReward: 'Reembolso de Perda',
      lossRewardSubtitle: 'Receba reembolso sobre suas perdas',
      rebateUpTo: 'Reembolso de até {ratio}%',
      notEligible: 'Você não pode mais participar desta atividade',
      lossNeedSelect: 'Selecione esta atividade ao depositar para participar do cashback',
      claimed: 'Resgatado',
      claim: 'Resgatar',
      noTier: 'Nenhum nível disponível',
      claimWillOpen: 'Resgate abre às {time}',
      claimTimeNotReached: 'O resgate ainda não está disponível. Volte após {time}.',
      bonus: 'Bônus',
      rebate: 'Reembolso',
      depositGE: 'Depósito ≥ {amount}',
      lossGE: 'Perda ≥ {amount}',
      claimSuccess: 'Resgatado com sucesso',
      claimFailed: 'Falha no resgate',
      alreadyClaimed: 'Você já resgatou este nível. Não clique novamente.',
      lossAlreadyClaimed: 'Você já resgatou o reembolso deste nível. Não clique novamente.',
      requireLogin: 'Faça login antes de resgatar.',
      depositNotEnough: 'Seu valor de depósito ainda não atingiu o requisito. Continue!',
      lossNotEnough: 'Sua perda de ontem não atingiu o requisito.',
      onlyHighest: 'Esta recompensa só permite resgatar o nível mais alto.',
    },
  },
};
